module.exports = {"120225001":"文昌街道","120225100":"渔阳镇","120225101":"洇溜镇","120225102":"官庄镇","120225103":"马伸桥镇","120225104":"下营镇","120225105":"邦均镇","120225106":"别山镇","120225108":"尤古庄镇","120225109":"上仓镇","120225111":"下仓镇","120225112":"罗庄子镇","120225113":"白涧镇","120225114":"五百户镇","120225115":"侯家营镇","120225116":"桑梓镇","120225117":"东施古镇","120225118":"下窝头镇","120225119":"杨津庄镇","120225120":"出头岭镇","120225121":"西龙虎峪镇","120225122":"穿芳峪镇","120225123":"东二营镇","120225124":"许家台镇","120225125":"礼明庄镇","120225126":"东赵各庄镇","120225203":"孙各庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120225.json
// module id = 141
// module chunks = 0